import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const StepFederalId = lazy(() =>
  import(/* webpackChunkName: "Register" */ '../containers/StepFederalId')
);
const StepUserInfo = lazy(() =>
  import(/* webpackChunkName: "Register" */ '../containers/StepUserInfo')
);
const StepCredentials = lazy(() =>
  import(/* webpackChunkName: "Register" */ '../containers/StepCredentials')
);

export default () => {
  return [
    <Route exact path="/indicacao/cadastro" component={StepFederalId} key="referralFederalId" />,
    <Route
      exact
      path="/indicacao/cadastro/dados-pessoais"
      component={StepUserInfo}
      key="referralUserInfo"
    />,
    <Route
      exact
      path="/indicacao/cadastro/credenciais"
      component={StepCredentials}
      key="referralCredentals"
    />,
  ];
};
